'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('hellosign/components/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _propTypes = require('./prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PropTypes = _react2['default'].PropTypes;


function ChangeFontButton(props) {
    var changeLinkClasses = {
        'm-sign-modal--tabs--type--output--change-link': true,
        'm-button': true,
        'bg-white': true,
        'border-1-light-grey': true,
        'hbg-white': true,
        'hc-light-grey': true,
        'c-light-grey': true
    };
    var spinner = _react2['default'].createElement('img', { src: require('./loading-spinner-16.gif'),
        className: 'm-sign-modal--tabs--type--output--spinner' });

    var changeLink = _react2['default'].createElement(
        'a',
        { className: (0, _classnames2['default'])(changeLinkClasses), onClick: props.handleClick },
        _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.typed.changeFonts.linkText' })
    );
    return _react2['default'].createElement(
        'div',
        { className: 'm-sign-modal--tabs--type--output' },
        changeLink,
        props.showSpinner ? spinner : null
    );
}

var TypeInTab = _react2['default'].createClass({
    displayName: 'TypeInTab',


    propTypes: _extends({}, _propTypes.CommonTabProps, {

        /**
         * Takes a callback that will be called when the network is checked and
         * verified to be working.
         */
        onCheckNetworkHealth: PropTypes.func,
        onSignatureData: _propTypes.OnSignatureData,
        initialValue: PropTypes.string.isRequired
    }),

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'canInsertEverywhere': true,
            onCheckNetworkHealth: function onCheckNetworkHealth(cb) {
                return cb();
            }
        };
    },
    getInitialState: function getInitialState() {
        var initialValue = this.props.initialValue;


        return {
            'hasValue': !!initialValue,
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
            'selectedFontIndex': 2,
            'showSpinner': false,
            'textValue': initialValue
        };
    },
    componentDidMount: function componentDidMount() {

        this.adjustInputWidth();

        // Load the initial font family
        var n = this.state.selectedFontIndex % _constants2['default'].CURSIVE_FONTS.length;
        var chosenFamily = _constants2['default'].CURSIVE_FONTS[n];
        this.loadFontFamily(chosenFamily);
    },
    componentDidUpdate: function componentDidUpdate() {
        this.adjustInputWidth();
    },


    //  ----  BEHAVIOR  -----------------------------------

    loadFontFamily: function loadFontFamily(fontFamily, okCallback) {

        var onActive = function onActive() {
            if (okCallback) {
                okCallback();
            }
        };

        var onInactive = function onInactive(stop) {

            if (stop === true) {
                console.error('Could not load font ' + fontFamily + ' at all');
                return;
            }

            if (process.env.NODE_ENV !== 'test') {
                console.error('Could not get font ' + fontFamily + ' from Google, loading from our servers instead');
            }

            // Load from CDN
            var cdnFontUrl = _hfReactHelper2['default'].urlHelper('/fonts/' + fontFamily.toLowerCase().replace(/\s/g, '-') + '.css', 'hellosign');
            WebFont.load({
                'custom': {
                    'families': [fontFamily],
                    'urls': [cdnFontUrl]
                },
                'active': onActive,
                'fontinactive': onInactive.bind(this, true)
            });
        };

        // Load font from google
        if (window.WebFont) {
            WebFont.load({
                'google': {
                    'families': [fontFamily]
                },
                'active': onActive,
                'fontinactive': onInactive
            });
        } else if (okCallback) {
            okCallback();
        }
    },
    selectNextFontFamily: function selectNextFontFamily() {

        var self = this;
        var n = (this.state.selectedFontIndex + 1) % _constants2['default'].CURSIVE_FONTS.length;
        var chosenFamily = _constants2['default'].CURSIVE_FONTS[n];

        this.setState({
            'showSpinner': true
        });

        var loadFont = function loadFont() {
            self.loadFontFamily(chosenFamily, function () {
                self.setState({
                    'showSpinner': false,
                    'selectedFontIndex': n // Will trigger the new css font-family to change
                });
            });
        };

        this.props.onCheckNetworkHealth(loadFont);
    },
    handleInput: function handleInput(evt) {
        var v = evt.target.value;
        this.setState({
            'textValue': v,
            'hasValue': v.replace(/\s/g, '').length > 0
        });
    },
    insertSignature: function insertSignature(insertEverywhere) {

        var text = _hfReactHelper2['default'].trim(this.state.textValue);

        var signatureData = {
            'type_code': this.props.type,
            'create_type_code': _constants2['default'].SIGNATURE_TYPE_TYPED,
            'signature': {
                'text': text,
                'font_family': _constants2['default'].CURSIVE_FONTS[this.state.selectedFontIndex]
            }
        };

        return this.props.onSignatureData(signatureData, insertEverywhere);
    },


    //  ----  HELPERS  ------------------------------------

    adjustInputWidth: function adjustInputWidth() {
        var root = this.node;
        var w = '385px';
        if (this.props.isMobile) {
            w = this.props.deviceOrientation === _constants2['default'].ORIENTATION_LANDSCAPE ? $('.m-sign-modal--tabs--type', root).width() - 140 + 'px' : '100%'; // 140 = size of the btn
        }
        $('#typedSignatureInput', root).css('width', w);
    },
    isChinese: function isChinese() {
        var intl = this.props.intl;
        var locale = intl ? intl.locale : null;
        return locale === 'zh-CN';
    },


    //  ----  RENDERING  ----------------------------------

    render: function render() {
        var _this = this;

        var actionBarProps = this.props.actionBarProps;


        var fontFamily = _constants2['default'].CURSIVE_FONTS[this.state.selectedFontIndex];
        var inputStyle = {
            'fontFamily': fontFamily
        };
        var inputClasses = {
            'm-sign-modal--tabs--type--input': true
        };
        var classes = {
            'm-sign-modal--tabs--type': true,
            'has-value': this.state.hasValue
        };
        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };

        containerClasses[_constants2['default'].TAB_TYPE] = true;
        inputClasses['font-' + fontFamily.replace(/\s/g, '-')] = true;

        var changeFontButton = _react2['default'].createElement(ChangeFontButton, _extends({}, this.props, {
            'data-test-ref': 'change-button',
            handleClick: this.selectNextFontFamily,
            showSpinner: this.state.showSpinner }));

        return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(containerClasses), ref: function ref(node) {
                    return _this.node = node;
                } },
            _react2['default'].createElement(
                'span',
                { className: 'm-sign-modal--tabs--tab-title' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, {
                    id: 'signModal.typed.title',
                    values: { type: this.props.type }
                })
            ),
            _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])(classes) },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--tabs--content', ref: this.props.captureTabContentRef },
                    _react2['default'].createElement('input', {
                        'data-test-ref': 'input',
                        id: 'typedSignatureInput',
                        ref: 'typedSignatureInput',
                        type: 'text',
                        className: (0, _classnames2['default'])(inputClasses),
                        style: inputStyle,
                        value: this.state.textValue,
                        onChange: this.handleInput,
                        onKeyUp: this.handleInput,
                        placeholder: this.props.intl.formatMessage({ id: 'signModal.typed.placeholder.' + this.props.type })
                    }),
                    !this.isChinese() ? changeFontButton : null
                )
            ),
            _react2['default'].createElement(_actionBar2['default'], _extends({}, actionBarProps, {
                'data-test-ref': 'action-bar',
                disableButtons: !this.state.hasValue,
                onInsert: this.insertSignature
            }))
        );
    }
});

module.exports = TypeInTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/type-in-tab.jsx
 ** module id = 810
 ** module chunks = 0 1
 **/